<template>
    <nav class="nav_center2" style="padding: 0; background: cadetblue">
        <ul class="" style="list-style: none">
            <li :class="{ topmenuactive: activeTab === 'HeThongCNTT' }" @click="changeTab('HeThongCNTT')">
                <a id="urlHeThongCNTT" href="vi/chuongtrinhtaitroxathidiem#cantho/hethongcntt" style="color: white;">
                {{ currentLanguage.header_text_hethongCNTT15 }}
                </a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'Xathanhxuan' }" @click="changeTab('Xathanhxuan')">
                <a id="urlXathanhxuan" href="vi/chuongtrinhtaitroxathidiem#cantho/xathanhxuan" style="color: white;">
                    {{ currentLanguage.header_text_ThanhXuan }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xadongphuoc' }" @click="changeTab('Xadongphuoc')">
                <a id="urlXadongphuoc" href="vi/chuongtrinhtaitroxathidiem#cantho/xadongphuoc" style="color: white;">
                    {{ currentLanguage.header_text_DongPhuoc }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xachauthanh' }" @click="changeTab('Xachauthanh')">
                <a id="urlXachauthanh" href="vi/chuongtrinhtaitroxathidiem#cantho/xachauthanh" style="color: white;">
                    {{ currentLanguage.header_text_ChauThanh }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xaphuhuu' }" @click="changeTab('Xaphuhuu')">
                <a id="urlXaphuhuu" href="vi/chuongtrinhtaitroxathidiem#cantho/xaphuhuu" style="color: white;">
                    {{ currentLanguage.header_text_PhuHuu }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xathanhhoa' }" @click="changeTab('Xathanhhoa')">
                <a id="urlXathanhhoa" href="vi/chuongtrinhtaitroxathidiem#cantho/xathanhhoa" style="color: white;">
                    {{ currentLanguage.header_text_ThanhHoa }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xaphunghiep' }" @click="changeTab('Xaphunghiep')">
                <a id="urlXaphunghiep" href="vi/chuongtrinhtaitroxathidiem#cantho/xaphunghiep" style="color: white;">
                    {{ currentLanguage.header_text_PhungHiep }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xatanbinh' }" @click="changeTab('Xatanbinh')">
                <a id="urlXatanbinh" href="vi/chuongtrinhtaitroxathidiem#cantho/xatanbinh" style="color: white;">
                    {{ currentLanguage.header_text_TanBinh }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xatanhoa' }" @click="changeTab('Xatanhoa')">
                <a id="urlXatanhoa" href="vi/chuongtrinhtaitroxathidiem#cantho/xatanhoa" style="color: white;">
                    {{ currentLanguage.header_text_TanHoa }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xanhonai' }" @click="changeTab('Xanhonai')">
                <a id="urlXanhonai" href="vi/chuongtrinhtaitroxathidiem#cantho/xanhonai" style="color: white;">
                    {{ currentLanguage.header_text_NhonAi }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xaphongdien' }" @click="changeTab('Xaphongdien')">
                <a id="urlXaphongdien" href="vi/chuongtrinhtaitroxathidiem#cantho/xaphongdien" style="color: white;">
                    {{ currentLanguage.header_text_PhongDien }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xatruonglong' }" @click="changeTab('Xatruonglong')">
                <a id="urlXatruonglong" href="vi/chuongtrinhtaitroxathidiem#cantho/xatruonglong" style="color: white;">
                    {{ currentLanguage.header_text_TruongLong }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xatruonglongtay' }" @click="changeTab('Xatruonglongtay')">
                <a id="urlXatruonglongtay" href="vi/chuongtrinhtaitroxathidiem#cantho/xatruonglongtay"
                    style="color: white;">
                    {{ currentLanguage.header_text_TruongLongTay }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xatruongthanh' }" @click="changeTab('Xatruongthanh')">
                <a id="urlXatruongthanh" href="vi/chuongtrinhtaitroxathidiem#cantho/xatruongthanh"
                    style="color: white;">
                    {{ currentLanguage.header_text_TruongThanh }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xathoilai' }" @click="changeTab('Xathoilai')">
                <a id="urlXathoilai" href="vi/chuongtrinhtaitroxathidiem#cantho/xathoilai" style="color: white;">
                    {{ currentLanguage.header_text_ThoiLai }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xatruongxuan' }" @click="changeTab('Xatruongxuan')">
                <a id="urlXatruongxuan" href="vi/chuongtrinhtaitroxathidiem#cantho/xatruongxuan" style="color: white;">
                    {{ currentLanguage.header_text_TruongXuan }}
                </a>
            </li>

            <li :class="{ topmenuactive: activeTab === 'Xavinhthuy' }" @click="changeTab('Xavinhthuy')"
                style="display: none;">
                <a id="urlXavinhthuy" href="vi/chuongtrinhtaitroxathidiem#cantho/xavinhthuy" style="color: white;">Vĩnh
                    Thủy</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'Xabenquan' }" @click="changeTab('Xabenquan')"
                style="display: none;">
                <a id="urlXabenquan" href="vi/chuongtrinhtaitroxathidiem#cantho/xabenquan" style="color: white;">Bến
                    Quan</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'xatanmy' }" @click="changeTab('xatanmy')"
                style="display: none;">
                <a id="urlxatanmy" href="vi/chuongtrinhtaitroxathidiem#cantho/xatanmy" style="color: white;">Tân Mỹ</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'Xagolinh' }" @click="changeTab('Xagolinh')"
                style="display: none;">
                <a id="urlXagolinh" href="vi/chuongtrinhtaitroxathidiem#cantho/xagolinh" style="color: white;">Gio
                    Linh</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'Xasengu' }" @click="changeTab('Xasengu')"
                style="display: none;">
                <a id="urlXasengu" href="vi/chuongtrinhtaitroxathidiem#cantho/xasengu" style="color: white;">Sen Ngư</a>
            </li>
            <li :class="{ topmenuactive: activeTab === 'Phuongcantho' }" @click="changeTab('Phuongcantho')"
                style="display: none;">
                <a id="urlPhuongcantho" href="vi/chuongtrinhtaitroxathidiem#cantho/phuongcantho"
                    style="color: white;">Phường Quảng Trị</a>
            </li>
        </ul>
    </nav>
    <div class="wrapper row3">
           <main class="hoc container-fluid clear bv p-0">

                    <div v-if="showHeThongCNTT" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlHeThongCNTT"></div>
                        <div v-html="contentHtmlHeThongCNTT || 'Đang cập nhập...'"></div>
                        <!-- Hoặc tạm: Đang cập nhật... -->
                    </div>
                    <!-- Xathanhxuan -->
                    <div v-if="showXaphuhuu" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXaphuhuu"></div>
                        <div v-html="contentHtmlXaphuhuu"></div>
                    </div>
                    <div v-if="showXadongphuoc" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXadongphuoc"></div>
                        <div v-html="contentHtmlXadongphuoc"></div>
                    </div>
                    <div v-if="showXathanhhoa" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXathanhhoa"></div>
                        <div v-html="contentHtmlXathanhhoa"></div>
                    </div>
                    <div v-if="showXatanbinh" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXatanbinh"></div>
                        <div v-html="contentHtmlXatanbinh"></div>
                    </div>
                    <div v-if="showXaphunghiep" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXaphunghiep"></div>
                        <div v-html="contentHtmlXaphunghiep"></div>
                    </div>
                    <div v-if="showXachauthanh" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXachauthanh"></div>
                        <div v-html="contentHtmlXachauthanh"></div>
                    </div>
                    <div v-if="showXatanhoa" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXatanhoa"></div>
                        <div v-html="contentHtmlXatanhoa"></div>
                    </div>
                    <div v-if="showXathanhxuan" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXathanhxuan"></div>
                        <div v-html="contentHtmlXathanhxuan"></div>
                    </div>

                    <div v-if="showXanhonai" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXanhonai"></div>
                        <div v-html="contentHtmlXanhonai"></div>
                    </div>
                    <div v-if="showXaphongdien" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXaphongdien"></div>
                        <div v-html="contentHtmlXaphongdien"></div>
                    </div>
                    <div v-if="showXatruonglong" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXatruonglong"></div>
                        <div v-html="contentHtmlXatruonglong"></div>
                    </div>

                    <div v-if="showXatruonglongtay" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXatruonglongtay"></div>
                        <div v-html="contentHtmlXatruonglongtay"></div>
                    </div>

                    <div v-if="showXatruongthanh" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXatruongthanh"></div>
                        <div v-html="contentHtmlXatruongthanh"></div>
                    </div>

                    <div v-if="showXathoilai" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXathoilai"></div>
                        <div v-html="contentHtmlXathoilai"></div>
                    </div>

                    <div v-if="showXatruongxuan" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXatruongxuan"></div>
                        <div v-html="contentHtmlXatruongxuan"></div>
                    </div>

                    <div v-if="showXavinhthuy" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXavinhthuy"></div>
                        <div v-html="contentHtmlXavinhthuy || 'Đang cập nhập...'"></div>
                    </div>
                    <div v-if="showXabenquan" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXabenquan"></div>
                        <div v-html="contentHtmlXabenquan || 'Đang cập nhập...'"></div>
                    </div>
                    <div v-if="showXagolinh" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXagolinh"></div>
                        <div v-html="contentHtmlXagolinh || 'Đang cập nhập...'"></div>
                    </div>
                    <div v-if="showXasengu" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXasengu"></div>
                        <div v-html="contentHtmlXasengu || 'Đang cập nhập...'"></div>
                    </div>
                    <div v-if="showPhuongcantho" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlPhuongcantho"></div>
                        <div v-html="contentHtmlPhuongcantho || 'Đang cập nhập...'"></div>
                    </div>
                    <div v-if="showXaTanMy" class="padding-top15">
                        <div class="title-bai-viet" v-html="titleHtmlXaTanMy"></div>
                        <div v-html="contentHtmlXaTanMy || 'Đang cập nhập...'"></div>
                    </div>
            
        </main>
    </div>
</template>

<script>
import {
    languages
} from "@/components/languages";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";

export default {
    components: {

    },
    data() {
        return {
            activeTab: 'Xathanhxuan',

            currentLanguage: languages.vi,
            lang: "",
            base64: "",
            base64Title: "",
            showHeThongCNTT: false,
            titleHtmlHeThongCNTT: "",
            contentHtmlHeThongCNTT: "",
            showXaphuhuu: false,
            showXadongphuoc: false,
            showXathanhhoa: false,
            showXatanbinh: false,
            showXaphunghiep: false,
            showXachauthanh: false,
            showXatanhoa: false,
            showXathanhxuan: false,
            showXanhonai: false,
            showXaphongdien: false,
            showUngDungAI: false,
            showXavinhthuy: false,
            showXabenquan: false,
            showXagolinh: false,
            showXasengu: false,
            showPhuongcantho: false,
            showXaTanMy: false,

            titleHtmlXavinhthuy: "",
            contentHtmlXavinhthuy: "",
            titleHtmlXabenquan: "",
            contentHtmlXabenquan: "",
            titleHtmlXagolinh: "",
            contentHtmlXagolinh: "",
            titleHtmlXasengu: "",
            contentHtmlXasengu: "",
            titleHtmlPhuongcantho: "",
            contentHtmlPhuongcantho: "",

            titleHtmlAITaiLopHoc: "",
            contentHtmlAITaiLopHoc: "",
            titleHtml: "",
            contentHtml: "",
            titleHtmlTruongTaiTro: "",
            contentHtmlTruongTaiTro: "",
            titleHtmlTH: "",
            contentHtmlTH: "",
            titleHtmlTHCS: "",
            contentHtmlTHCS: "",
            titleHtmlTHPT: "",
            contentHtmlTHPT: "",
            titleHtmlLienHe: "",
            contentHtmlLienHe: "",
            titleHtmlLienCap: "",
            contentHtmlLienCap: "",
            titleHtmlXanhonai: "",
            contentHtmlXanhonai: "",
            titleHtmlXaphuhuu: "",
            contentHtmlXaphuhuu: "",
            titleHtmlXaphongdien: "",
            contentHtmlXaphongdien: "",

            titleHtmlXathanhxuan: "",
            titleHtmlXadongphuoc: "",
            titleHtmlXathanhhoa: "",
            titleHtmlXatanbinh: "",
            titleHtmlXaphunghiep: "",
            titleHtmlXachauthanh: "",
            titleHtmlXatanhoa: "",
            titleHtmlXaTanMy: "",
            contentHtmlXaTanMy: "",

            contentHtmlXathanhxuan: "",
            contentHtmlXadongphuoc: "",
            contentHtmlXatanbinh: "",
            contentHtmlXathanhhoa: "",
            contentHtmlXaphunghiep: "",
            contentHtmlXachauthanh: "",
            contentHtmlXatanhoa: "",
            showXatruonglong: false,
            showXatruonglongtay: false,
            showXatruongthanh: false,
            showXathoilai: false,
            showXatruongxuan: false,

            titleHtmlXatruonglong: "",
            contentHtmlXatruonglong: "",
            titleHtmlXatruonglongtay: "",
            contentHtmlXatruonglongtay: "",
            titleHtmlXatruongthanh: "",
            contentHtmlXatruongthanh: "",
            titleHtmlXathoilai: "",
            contentHtmlXathoilai: "",
            titleHtmlXatruongxuan: "",
            contentHtmlXatruongxuan: "",
        };
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true;
            this.lang = localStorage.getItem("languages") || "vi";
            // this.performPostRequest("", "Xathanhxuan", this.lang);
            document.getElementById("urlHeThongCNTT").setAttribute(
                "href",
                this.lang + "/chuongtrinhtaitroxathidiem#cantho/hethongcntt"
            );
            document.getElementById("urlXathanhxuan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xathanhxuan");
            document.getElementById("urlXathanhhoa").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xathanhhoa");
            document.getElementById("urlXadongphuoc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xadongphuoc");
            document.getElementById("urlXaphuhuu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xaphuhuu");
            document.getElementById("urlXachauthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xachauthanh");
            document.getElementById("urlXatanhoa").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatanhoa");
            document.getElementById("urlXaphunghiep").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xaphunghiep");
            document.getElementById("urlXatanbinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatanbinh/");
            document.getElementById("urlXanhonai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xanhonai/");
            document.getElementById("urlXaphongdien").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xaphongdien");
            document.getElementById("urlXavinhthuy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xavinhthuy");
            document.getElementById("urlXabenquan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xabenquan");
            document.getElementById("urlXagolinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xagolinh");
            document.getElementById("urlXasengu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xasengu");
            document.getElementById("urlPhuongcantho").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/phuongcantho");
            document.getElementById("urlXatruonglong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatruonglong");
            document.getElementById("urlXatruonglongtay").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatruonglongtay");
            document.getElementById("urlXatruongthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatruongthanh");
            document.getElementById("urlXathoilai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xathoilai");
            document.getElementById("urlXatruongxuan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatruongxuan");
            document.getElementById("urlxatanmy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#cantho/xatanmy");

            let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
            console.log("fragmentTab " + fragmentTab);

            if (fragmentTab === "cantho/xathanhxuan") {
                this.changeTab("Xathanhxuan");
            } else if (fragmentTab === "cantho/xathanhhoa") {
                this.changeTab("Xathanhhoa");
            } else if (fragmentTab === "cantho/xadongphuoc") {
                this.changeTab("Xadongphuoc");
            } else if (fragmentTab === "cantho/xaphuhuu") {
                this.changeTab("Xaphuhuu");
            } else if (fragmentTab === "cantho/xatanbinh") {
                this.changeTab("Xatanbinh");
            } else if (fragmentTab === "cantho/xaphunghiep") {
                this.changeTab("Xaphunghiep");
            } else if (fragmentTab === "cantho/xachauthanh") {
                this.changeTab("Xachauthanh");
            } else if (fragmentTab === "cantho/xatanhoa") {
                this.changeTab("Xatanhoa");
            } else if (fragmentTab === "cantho/xanhonai") {
                this.changeTab("Xanhonai");
            } else if (fragmentTab === "cantho/xaphongdien") {
                this.changeTab("Xaphongdien");
            } else if (fragmentTab === "cantho/xavinhthuy") {

                this.changeTab("Xavinhthuy")
            } else if (fragmentTab === "cantho/xabenquan") {
                this.changeTab("Xabenquan");
            } else if (fragmentTab === "cantho/xagolinh") {
                this.changeTab("Xagolinh");
            } else if (fragmentTab === "cantho/xasengu") {
                this.changeTab("Xasengu");
            } else if (fragmentTab === "cantho/phuongcantho") {
                this.changeTab("Phuongcantho");
            } else if (fragmentTab === "cantho/hethongcntt") {
                this.changeTab("HeThongCNTT");
            } else if (fragmentTab === "cantho/xatruonglong") {
                this.changeTab("Xatruonglong");
            } else if (fragmentTab === "cantho/xatruonglongtay") {
                this.changeTab("Xatruonglongtay");
            } else if (fragmentTab === "cantho/xatruongthanh") {
                this.changeTab("Xatruongthanh");
            } else if (fragmentTab === "cantho/xathoilai") {
                this.changeTab("Xathoilai");
            } else if (fragmentTab === "cantho/xatruongxuan") {
                this.changeTab("Xatruongxuan");
            } else if (fragmentTab === "cantho/xatanmy") {
                this.changeTab("XaTanMy");
            } else {
                // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
                this.changeTab("HeThongCNTT");
            }
        }
    },
    created() {
        const savedLanguage = localStorage.getItem("languages");
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    methods: {
        changeLanguage(lang) {
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            window.location.reload();
        },

        async performPostRequest(id, section) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store separately for each section
                if (section === "Xaphuhuu") {
                    this.titleHtmlXaphuhuu = decodeURIComponent(escape(title));
                    this.contentHtmlXaphuhuu = decodeURIComponent(escape(decodedString));
                } else if (section === "Xadongphuoc") {
                    this.titleHtmlXadongphuoc = decodeURIComponent(escape(title));
                    this.contentHtmlXadongphuoc = decodeURIComponent(escape(decodedString));
                } else if (section === "Xathanhhoa") {
                    this.titleHtmlXathanhhoa = decodeURIComponent(escape(title));
                    this.contentHtmlXathanhhoa = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatanbinh") {
                    this.titleHtmlXatanbinh = decodeURIComponent(escape(title));
                    this.contentHtmlXatanbinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaphunghiep") {
                    this.titleHtmlXaphunghiep = decodeURIComponent(escape(title));
                    this.contentHtmlXaphunghiep = decodeURIComponent(escape(decodedString));
                } else if (section === "Xachauthanh") {
                    this.titleHtmlXachauthanh = decodeURIComponent(escape(title));
                    this.contentHtmlXachauthanh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatanhoa") {
                    this.titleHtmlXatanhoa = decodeURIComponent(escape(title));
                    this.contentHtmlXatanhoa = decodeURIComponent(escape(decodedString));
                } else if (section === "Xathanhxuan") {
                    this.titleHtmlXathanhxuan = decodeURIComponent(escape(title));
                    this.contentHtmlXathanhxuan = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanhonai") {
                    this.titleHtmlXanhonai = decodeURIComponent(escape(title));
                    this.contentHtmlXanhonai = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaphongdien") {
                    this.titleHtmlXaphongdien = decodeURIComponent(escape(title));
                    this.contentHtmlXaphongdien = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatruonglong") {
                    this.titleHtmlXatruonglong = decodeURIComponent(escape(title));
                    this.contentHtmlXatruonglong = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatruonglongtay") {
                    this.titleHtmlXatruonglongtay = decodeURIComponent(escape(title));
                    this.contentHtmlXatruonglongtay = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatruongthanh") {
                    this.titleHtmlXatruongthanh = decodeURIComponent(escape(title));
                    this.contentHtmlXatruongthanh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xathoilai") {
                    this.titleHtmlXathoilai = decodeURIComponent(escape(title));
                    this.contentHtmlXathoilai = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatruongxuan") {
                    this.titleHtmlXatruongxuan = decodeURIComponent(escape(title));
                    this.contentHtmlXatruongxuan = decodeURIComponent(escape(decodedString));
                } else if (section === "Xavinhthuy") {
                    this.titleHtmlXavinhthuy = decodeURIComponent(escape(title));
                    this.contentHtmlXavinhthuy = decodeURIComponent(escape(decodedString));
                } else if (section === "Xabenquan") {
                    this.titleHtmlXabenquan = decodeURIComponent(escape(title));
                    this.contentHtmlXabenquan = decodeURIComponent(escape(decodedString));
                } else if (section === "Xagolinh") {
                    this.titleHtmlXagolinh = decodeURIComponent(escape(title));
                    this.contentHtmlXagolinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xasengu") {
                    this.titleHtmlXasengu = decodeURIComponent(escape(title));
                    this.contentHtmlXasengu = decodeURIComponent(escape(decodedString));
                } else if (section === "Phuongcantho") {
                    this.titleHtmlPhuongcantho = decodeURIComponent(escape(title));
                    this.contentHtmlPhuongcantho = decodeURIComponent(escape(decodedString));
                } else if (section === "HeThongCNTT") {
                    this.titleHtmlHeThongCNTT = decodeURIComponent(escape(title));
                    this.contentHtmlHeThongCNTT = decodeURIComponent(escape(decodedString));
                } else if (section === "XaTanMy") {
                    this.titleHtmlXaTanMy = decodeURIComponent(escape(title));
                    this.contentHtmlXaTanMy = decodeURIComponent(escape(decodedString));
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        changeTab(tab) {
            //   if (window.innerWidth <= 768) {
            //     this.isMenuVisible = false;
            //   }
            this.lang = localStorage.getItem("languages");

            const tabStates = {

                Xaphuhuu: false,
                Xadongphuoc: false,
                Xathanhhoa: false,
                Xatanbinh: false,
                ungDungAI: false,
                Xathanhxuan: false,
                Xaphunghiep: false,
                Xachauthanh: false,
                Xatanhoa: false,
                Xanhonai: false,
                Xaphongdien: false,
                Xatruonglong: false,
                Xatruonglongtay: false,
                Xatruongthanh: false,
                Xathoilai: false,
                Xatruongxuan: false,
                Xavinhthuy: false,
                Xabenquan: false,
                Xagolinh: false,
                Xasengu: false,
                Phuongcantho: false,
                HeThongCNTT: false,
                XaTanMy: false,

            };

            this.performPostRequest(this.getPostId(tab), tab, this.lang);

            tabStates[tab] = true;
            this.activeTab = tab;
            this.showXaphuhuu = tabStates.Xaphuhuu;
            this.showXadongphuoc = tabStates.Xadongphuoc;
            this.showXathanhhoa = tabStates.Xathanhhoa;
            this.showXatanbinh = tabStates.Xatanbinh;
            this.showXaphunghiep = tabStates.Xaphunghiep;
            this.showXachauthanh = tabStates.Xachauthanh;
            this.showXatanhoa = tabStates.Xatanhoa;
            this.showXathanhxuan = tabStates.Xathanhxuan;
            this.showXanhonai = tabStates.Xanhonai;
            this.showXaphongdien = tabStates.Xaphongdien;
            this.showXatruonglong = tabStates.Xatruonglong;
            this.showXatruonglongtay = tabStates.Xatruonglongtay;
            this.showXatruongthanh = tabStates.Xatruongthanh;
            this.showHeThongCNTT = tabStates.HeThongCNTT;

            this.showXathoilai = tabStates.Xathoilai;
            this.showXatruongxuan = tabStates.Xatruongxuan;
            this.showXavinhthuy = tabStates.Xavinhthuy;
            this.showXabenquan = tabStates.Xabenquan;
            this.showXagolinh = tabStates.Xagolinh;
            this.showXasengu = tabStates.Xasengu;
            this.showPhuongcantho = tabStates.Phuongcantho;
            this.showXaTanMy = tabStates.XaTanMy;
        },
        getPostId(tab) {
            // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
            const postIdMap = {
                Xaphuhuu: "1757907849779L7mLS",
                Xadongphuoc: "1757900976475w2V0K",
                Xathanhhoa: "17579078824273i73X",
                Xatanbinh: "1757754011341VuOXX",
                Xaphunghiep: "1757907911120gOHkf",
                Xachauthanh: "1757907941007hGvZj",
                Xatanhoa: "1757907970817XRaTR",
                Xathanhxuan: "1757870798888fk1bj",
                Xanhonai: "1757907991521IkBtF",
                Xaphongdien: "1757900933143RsgmP",
                Xatruonglong: "17577374535788LQ2O",
                Xatruonglongtay: "1757753928805U0VJb",
                Xatruongthanh: "1757754050557dgT2F",
                Xathoilai: "17579080292745Ddt2",
                HeThongCNTT: "1757580752227h0dUd",

                Xatruongxuan: "17579080592099ReiU",
                Xavinhthuy: "",
                Xabenquan: "",
                Xagolinh: "",
                Xasengu: "",
                Phuongcantho: "",
                XaTanMy: "",
            };

            return postIdMap[tab];
        },
    },
};
</script>

<style scoped>
/* nav ul li a {
    font-size: 14px;
} */
</style>
